import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OfferCardData } from "../../offer-card-data.model";
import { Currency } from "../../../../model/landingModel";
import { LoyaltyMode } from "@shopping-angular-components/loyalty";
import { ModalData } from '@shopping-angular-components/modal';
import { CommonModalContentComponent } from 'projects/common/components/modal/common-modal-content/common-modal-content.component';
import { AbstractOfferCard } from '../abstract-offer-card.component';

@Component({
  selector: 'common-offer-card',
  template: `
    <offer-card [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId" [positionIndex]="positionIndex"
                [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                [flow]="flow" [product]="product" [sboxAutocomplete]="sboxAutocomplete" [isFixedWidth]="isFixedWidth" [moduleReferer]="moduleReferer" (offerClicked)="onOfferClicked()">
      <offer-image offer-image 
        [highlighted]="highlighted" [product]="product"
        [mediaKey]="data.picture_link"
        [alt]="data.product_text + ' - ' + data.main_text"></offer-image>

      <ng-container offer-content>
        <offer-card-info [moduleId]="moduleId" [moduleIndex]="moduleIndex"
                         [positionIndex]="positionIndex"
                         [data]="data" [loyaltyMode]="loyaltyMode" [locale]="locale"
                         [flow]="flow" [currency]="currency" [sboxAutocomplete]="sboxAutocomplete"></offer-card-info>

        <offer-drivers [drivers]="data.drivers" [offerType]="data.offer_type" [stars]="data.stars"></offer-drivers>

        <div class="offer-card-description-container" *ngIf="data.description">
          <p class="offer-card-description-content offer-card-description" [innerHTML]="data.description"></p>
        </div>

        <eva-button *ngIf="data.modal" [options]="{type: 'none', link_text: ('offers.buttons.seeMoreDetails' | translate), stop_propagation: true}" class="-eva-3-mt-md -eva-3-mb-sm" [modalData]="modalData" [moduleId]="this.moduleId"></eva-button>
      </ng-container>
    </offer-card>
  `,
  styleUrls: ['./common-offer-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonOfferCardComponent extends AbstractOfferCard implements OnInit {
  @Input() highlighted = false;
  @Input() sboxAutocomplete?: boolean;
  @Input() isFixedWidth: boolean;

  modalData: ModalData;

  ngOnInit() {
    if (this.data.modal) {
      this.modalData = {
        id: this.moduleId + '-modal',
        title: "",
        contentComponent: CommonModalContentComponent,
        contentModel: {
          data: this.data.modal
        },
        product: this.product,
        flow: this.flow,
        isWebview: false,
        evaClasses: '-no-padding'
      }
    }
  }
}
